import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Type {
  id: string
  name: string
}

export interface UseTypesResult {
  types: Type[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useTypes(fetchOnMount = false): UseTypesResult {
  const [types, setTypes] = useState<Type[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ types: Type[] }>('/admin/conversation-management/types/dropdown')
      console.log('Types response:', res)
      setTypes(res.types || [])
    } catch (e) {
      console.error('Failed to fetch types:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch types')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { types, loading, error, refetch }
}
